var buildFormInDiv = require('./ui/buttons.js');
var Dispatcher = require('./dispatcher.js');
var _ = require('underscore');

function API(div, controlDiv, plotsInfo) {
    var myDispatcher = Dispatcher.getDispatcher();
    return {
        plotDiv: div,
        controlDiv: controlDiv,
        // Our storage of the plotly data/traces being plotted right now
        dataCache: [],

        initMeteorogram: function(plot_div, plotOrder) {
            this.hasGraph = true;
            this.plotDiv = plot_div || this.plotDiv;
            //start with only the selected plots showing, reveal others only if their data is requested
            myDispatcher.dispatch({
                'status': 'initPlot',
                'emit': 'plotEmitter',
                'location': this.plotDiv,
                'dataCache': this.dataCache,
                'plotsInfo': plotsInfo,
                'plotOrder': plotOrder
            });
        },
        initMeteorogramTable: function(table_div,plotOrder) {
            this.hasTable = true;
            this.tableDiv = table_div || this.plotDiv;
            //start with only the selected plots showing, reveal others only if their data is requested
            myDispatcher.dispatch({
                'status': 'initTable',
                'emit': 'plotEmitter',
                'location': this.tableDiv,
                'plotsInfo': plotsInfo,
                'plotOrder': plotOrder,
            });
        },

        initMeteorogramControls:function(plotOrder){
            buildFormInDiv(this.controlDiv, this.plotDiv,myDispatcher);
        },

        displayRealTime: function() {
            if (this.hasTable) {
                myDispatcher.dispatch({
                    'status':'update_table',
                    'emit':'plotEmitter',
                    'time':'-3:00:00',
                    'location':this.tableDiv
                });
            }
            if (this.hasGraph) {
                myDispatcher.dispatch({
                    'status':'get_since_now',
                    'emit':'plotEmitter',
                    'time':'-3:00:00',
                    'location':this.plotDiv
                });
            }
        },

        showPlot:function(varName){
            myDispatcher.dispatch({status: ('show' + varName), 'emit': 'checkboxEmitter','location':this.div});
        },

        hidePlot:function(varName){
            myDispatcher.dispatch({status: ('hide' + varName), 'emit': 'checkboxEmitter','location':this.div});
        },

        displayRecent: function(start_time) {
            // interval, if not provided, will be determined based on start time
            myDispatcher.dispatch({
                'status': 'get_since_now',
                'emit': 'plotEmitter',
                'time': start_time,
            });
        },

        displayTimeRange: function(start_time, stop_time, interval) {
            myDispatcher.dispatch({
                'status':'get_between_dates',
                'emit':'plotEmitter',
                'start':start_time,
                'end':stop_time,
                'interval':interval||'auto',
            });

        },
    }
}

//expose the API to other scripts
window.MeteorogramController = API;
